import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({

  cancelButtonLabel: {
    id: 'authoring.baseModal.cancelButtonLabel',
    defaultMessage: 'Cancel',
    description: 'Label for cancel button.',
  },
});

export default messages;
